var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: " http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4110_27149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.708984 2.83166V7.08166M0.708984 7.08166H4.95898M0.708984 7.08166L3.99565 3.99332C4.75693 3.23166 5.69875 2.67526 6.73322 2.37604C7.7677 2.07682 8.86112 2.04452 9.91145 2.28217C10.9618 2.51982 11.9348 3.01967 12.7397 3.73508C13.5446 4.45048 14.1552 5.35813 14.5144 6.37332M16.2923 14.165V9.91499M16.2923 9.91499H12.0423M16.2923 9.91499L13.0057 13.0033C12.2444 13.765 11.3026 14.3214 10.2681 14.6206C9.2336 14.9198 8.14019 14.9521 7.08985 14.7145C6.03952 14.4768 5.06651 13.977 4.26161 13.2616C3.4567 12.5462 2.84614 11.6385 2.4869 10.6233",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4110_27149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switch-icon.c6630c43a005052316490551944e5946.svg";
export { ForwardRef as ReactComponent };